import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { autoAnimatePlugin } from '@formkit/auto-animate/vue'
import './assets/tailwind.css'
import { installSmoothImages } from './utils/smoothImages'

store.dispatch("initAuth").finally(() => {
  createApp(App).use(autoAnimatePlugin).use(store).use(router).mount('#app')
  installSmoothImages()
})
